import { useState } from 'react';
import { Icon, ImageSrc } from '../../../components/Images';
import { ImgGalery } from '../../../components/ImgGalery';
import { ImagesListType } from 'react-spring-lightbox';
import _ from 'lodash';

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { FFtoggle, FFratio, selectFFRewards } from './slice';

const images: ImagesListType = [];
for (const index of _.range(1, 6, 1)) {
    images.push({
        src: ImageSrc.raw(`events/jigsaw-${index}`),
        loading: 'lazy',
        alt: 'Jigsaw Puzzle Solution',
    })
}

export function EventsFF() {
    const state = useAppSelector(selectFFRewards);
    const dispatch = useAppDispatch();

    const [galeryIsOpen, setGaleryIsOpen] = useState(false);
    const [currentImageIndex, setCurrentIndex] = useState(0);
    const imgStyle = {
        width: '150px',
        heigth: 'auto',
        borderRadius: '15px',
    }

    const imgW = 600;
    const imgH = 708;
    const tableMarginL = imgW*0.12;
    const tableMarginR = imgW*0.095;
    const tableMarginT = imgH*0.142;
    const tableMarginB = imgH*0.073;

    const containerSize = {
        height: `${imgH}px`,
    };
    const wrapperSize = {
        marginLeft: `calc((100% - ${imgW}px)/2)`,
    };
    const imgSize = {
        width: `${imgW}px`,
        height: `${imgH}px`,
    };
    const tableRect = {
        width: `${imgW-tableMarginL-tableMarginR}px`,
        height: `${imgH-tableMarginT-tableMarginB}px`,
        marginLeft: `${tableMarginL}px`,
        marginRight: `${tableMarginR}px`,
        marginTop: `${tableMarginT}px`,
        marginBottom: `${tableMarginB}px`,
        //backgroundColor: 'rgba(0, 1, 0, 0.7)',
        borderSpacing: '7px',
    };
    const tdBase = {
        borderRadius: '10px',
        cursor: 'pointer',
    }
    const tdOff = {
        ...tdBase,
        //border: '7px solid gray',
        backgroundColor: 'rgba(0, 1, 0, 0.3)',
    }
    const tdOn = {
        ...tdBase,
        //border: '7px solid green',
    }

    const infoStyle = {
        border: '2px solid gray',
        width: `${imgW*0.6}px`,
        height: `1em`,
        left: `${imgW*0.18}px`,
        top: `${imgH*0.08}px`,
    };

    const itemsX = Array(8).fill(0);
    const itemsY = Array(3).fill(0);

    const costs = {
        '0-0': 10, '0-1': 15, '0-2': 10,
        '1-0': 30, '1-1': 40, '1-2': 40,
        '2-0': 50, '2-1': 75, '2-2': 60,
        '3-0': 100, '3-1': 150, '3-2': 100,
        '4-0': 230, '4-1': 230, '4-2': 200,
        '5-0': 400, '5-1': 550, '5-2': 300,
        '6-0': 500, '6-1': 600, '6-2': 400,
        '7-0': 500, '7-1': 500, '7-2': 4,
    }

    var stars = 0;
    for (const [key, cost] of Object.entries(costs)) {
        if (state.items[key]) stars += cost;
    }

    var currency = Math.floor(stars / state.ratio);

    return (
        <div>
        <div className='ihContainer' style={containerSize}>
            <div className='relative-container' style={wrapperSize}>
                <img className='floating-overlay' src={ImageSrc.layout('FF')} alt={`Go to item.title`} style={imgSize} />
                <table className='floating-overlay' style={tableRect}>
                    <tbody>
                    {itemsX.map((_, x) => 
                        <tr key={x}>
                        {itemsY.map((_, y) => 
                            <td key={y} style={state.items[`${x}-${y}`] ? tdOn : tdOff} onClick={() => dispatch(FFtoggle(`${x}-${y}`))}></td>
                        )}
                        </tr>
                    )}
                    </tbody>
                </table>
                <div className='floating-overlay ihContainer' style={infoStyle}>
                    <div style={{width: '50%', display: 'inline-block', textAlign: 'right'}}>
                        Used {stars} ★
                    </div>
                    <div style={{width: '50%', display: 'inline-block', textAlign: 'left'}}>
                        &nbsp;/&nbsp;
                        <input className='ih-input number' aria-label={`Star count to get currency`}
                            type="number" 
                            value={state.ratio} 
                            onChange={(e) => dispatch(FFratio(Number(e.target.value)))}
                            style={{width: '2em', fontSize: '.9em'}}
                        />
                        &nbsp;=&nbsp; {currency}
                    </div>
                </div>
            </div>
        </div>
        <div className='ihContainer icons-picker horizontal'>
            <div>Jigsaw Puzzles (214-234)</div>
            <ImgGalery images={images} showIndex={currentImageIndex} isOpen={galeryIsOpen} onClose={() => setGaleryIsOpen(false)}/>
            {images.map((map, i) => 
                <Icon
                    key={`Jigsaw-${i}`}
                    src={map.src} title={map.alt}
                    size='preview-l'
                    style={{...imgStyle}}
                    onClick={() => { setCurrentIndex(i); setGaleryIsOpen(!galeryIsOpen);}} />
            )}
        </div>
        </div>
    );
}

